import styled from 'styled-components';
import { ICON_CLASS, LOGO_ICON_CLASS } from '../Icons/tokens';
import { theme } from '../theme';
import { getColorCode } from '../theme/utils';
export const RadialIconContainer = styled.div.attrs((props)=>{
    return {
        size: props.size ?? theme.sizes.x48,
        gradient: props.gradient ?? true
    };
})`
  width: ${({ size })=>size};
  height: ${({ size })=>size};
  border-radius: 50%;
  padding: ${theme.spaces.x12};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ gradient, tone, disabled })=>{
    if (disabled) return theme.colors.gray100;
    else if (gradient) return `radial-gradient(${getColorCode(tone, 100)} 50%, ${getColorCode(tone, 50)} 50%)`;
    else return getColorCode(tone, 100);
}};
  .${ICON_CLASS} {
    color: ${({ tone, disabled })=>disabled ? theme.colors.gray300 : getColorCode(tone, 600)};
    font-size: ${({ size, gradient })=>`calc(${size} * ${gradient ? 0.4 : 0.5})`};
  }
  .${LOGO_ICON_CLASS} {
    filter: ${({ disabled })=>disabled ? 'grayscale(1)' : 'grayscale(0)'};
    width: ${({ size, gradient })=>`calc(${size} * ${gradient ? 0.4 : 0.5})`};
    height: ${({ size, gradient })=>`calc(${size} * ${gradient ? 0.4 : 0.5})`};
  }
`;
